<template>
  <v-text-field
    name="search"
    label="Search"
    id="searchInput"
    :autofocus="autofocus"
    color="#f6a200"
    v-model="query"
    autocomplete="off"
    >
  </v-text-field>
</template>

<script>
import { Input } from 'vue-instantsearch'

export default {
  name: 'ais-input',
  extends: Input,
  data () {
    return {
      blockClassName: 'ais-input'
    }
  },
  props: {
    autofocus: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    query: {
      get () {
        return this.searchStore.query
      },
      set (value) {
        this.searchStore.stop()
        this.searchStore.query = value
        this.$emit('query', value)

        // We here ensure we give the time to listeners to alter the store's state
        // without triggering in between ghost queries.
        this.$nextTick(function () {
          this.searchStore.start()
          // Remove the auto search
          // this.searchStore.refresh();
        })
      }
    }
  }
}
</script>
